import React from 'react';

interface DashboardCardProps {
  icon: React.ReactNode;
  label: string;
  active?: boolean;
  onClick?: () => void;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  icon,
  label,
  active = false,
  onClick,
}) => {
  return (
    <div
      className={`dashboard__card ${active ? 'active' : ''}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' && onClick) onClick();
      }}
    >
      <div className="dashboard__card-icon">{icon}</div>
      <div className="dashboard__card-label">{label}</div>
    </div>
  );
};

export default DashboardCard;
